import React from "react";
import style from "./IAgreePopup.module.css";
import CustomButton from "../../Commons/Button/CustomButton";

function IAgreePopup({ close, setVal, val }) {
  return (
    <div className="main_popup">
      <div className={`${style.card} main_popup_card`}>
        <iframe
          className={style.iframe}
          src="https://greenpaynetwork.co.in/TermsOfUse.html"
          title="Iframe Example"
        ></iframe>

        <div className={style.btn_Container}>
          <CustomButton
            txt={"cancel"}
            OnClickFunc={() => {
              close(false);
            }}
          />
          <CustomButton
            OnClickFunc={() => {
              setVal({ ...val, consent: true });
              close(false);
            }}
            txt={"I agree"}
          />
        </div>
      </div>
    </div>
  );
}

export default IAgreePopup;
